// Static route table for the area; pages load lazily (one chunk + its CSS).
import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/waves/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const wavesRoutes: RouteObject[] = [
  {
    path: 'waves',
    handle: crumb('Waves'),
    children: [
      { index: true, lazy: page('WaveListPage') },
      { path: 'create', handle: crumb('Create'), lazy: page('WaveCreatePage') },
      {
        path: ':id',
        handle: { crumb: (match) => match.params.id ?? null } satisfies CrumbHandle,
        children: [
          { index: true, lazy: page('WaveEditPage') },
          { path: 'show', handle: crumb('Show'), lazy: page('WaveShowPage') }
        ]
      }
    ]
  }
]
